import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {faPen, faTrash} from '@fortawesome/free-solid-svg-icons';
import {LocationDataProcessMeasure} from '../../../classes/offset/LocationDataProcessMeasure';
import {ActivatedRoute} from '@angular/router';
import {ProjectMeasureService} from '../../../services/project-measure/project-measure.service';
import {ProjectService} from '../../../services/project/project.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Location} from '../../../types/location.type';

@Component({
  selector: 'app-eraser-form',
  templateUrl: './eraser-form.component.html',
  styleUrls: ['./eraser-form.component.css']
})
export class EraserFormComponent implements OnInit {

  private _selectedLocation: Location.serverSide;
  @Output() showSpinner: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() set selectedLocation(value) {
    this._selectedLocation = value;
    this.getDataProcessMeasures(this.selectedLocation.id);
  }
  get selectedLocation(): Location.serverSide {
    return this._selectedLocation;
  }
  @Input() dateStart: Date;

  faPen = faPen;
  faTrash = faTrash;
  dateStartPickerPatcheEraser: Date;
  timeStartPickerPatcheEraser: {
    hour: number;
    minute: number;
    second: number;
  };
  dateEndPickerPatcheEraser: Date;
  timeEndPickerPatcheEraser: {
    hour: number;
    minute: number;
    second: number;
  };
  dateStartPicker: Date;
  timeStartPicker: {
    hour: number;
    minute: number;
    second: number;
  };
  dateEndPicker: Date;
  timeEndPicker: {
    hour: number;
    minute: number;
    second: number;
  };
  comment = '';

  selectedLocationDataProcessMeasures: any;
  disabled = false;

  constructor(private route: ActivatedRoute,
              private projectMeasureService: ProjectMeasureService,
              private projectService: ProjectService,
              private translateService: TranslateService,
              private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.initDateTimePickers(this.dateStart);
  }

  private initDateTimePickers(date?) {
    this.dateStartPicker = this.dateEndPicker  = this.projectMeasureService.initDatePicker(date);
    this.timeStartPicker = this.timeEndPicker = this.projectMeasureService.initTimePicker(date);
  }

  setDatePatchErase(startDate, endDate, index: number) {
    for (const selectedLocationDataProcessMeasuresKey in this.selectedLocationDataProcessMeasures) {
      if (selectedLocationDataProcessMeasuresKey === index.toString()) {
        this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].selected = true;
      } else {
        this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].selected = false;
      }
    }
    const dateStartObject = new Date(startDate);
    this.dateStartPickerPatcheEraser = dateStartObject;
    this.timeStartPickerPatcheEraser = {
      hour: dateStartObject.getUTCHours(),
      minute: dateStartObject.getUTCMinutes(),
      second: dateStartObject.getUTCSeconds(),
    };
    const dateEndObject = new Date(endDate);
    this.dateEndPickerPatcheEraser = dateEndObject;
    this.timeEndPickerPatcheEraser = {
      hour: dateEndObject.getUTCHours(),
      minute: dateEndObject.getUTCMinutes(),
      second: dateEndObject.getUTCSeconds(),
    };
  }

  deleteDataProcessMeasures(dataProcessingMeasureId) {
    if (confirm(this.translateService.instant('DELETE_ERASER'))) {
      this.projectMeasureService.deleteLocationDataProcessMeasure(dataProcessingMeasureId).subscribe(
        () => {
          this.toastr.success(this.translateService.instant('ERASER_DELETED'));
          this.getDataProcessMeasures(this.selectedLocation.id);
        },
      );
    }
  }

  patchDataProcessMeasures(dataProcessingMeasure) {
    const payload: LocationDataProcessMeasure = {
      type: 'erase',
      project_device_location: this.selectedLocation.id,
      comment: dataProcessingMeasure.new_comment || dataProcessingMeasure.comment
    };

    payload.start_date = this.projectMeasureService.formatDateToString(this.timeStartPickerPatcheEraser, this.dateStartPickerPatcheEraser);
    payload.end_date = this.projectMeasureService.formatDateToString(this.timeEndPickerPatcheEraser, this.dateEndPickerPatcheEraser);
    this.projectMeasureService.patchLocationDataProcessMeasure(dataProcessingMeasure.id, payload)
      .subscribe(
        () => {
          this.toastr.success(this.translateService.instant('ERASER_UPDATED'));
          this.getDataProcessMeasures(this.selectedLocation.id);
        },
        () => this.showSpinner.emit(false)
      );
  }

  submit() {
    if (Object.getOwnPropertyNames(this.selectedLocation).length === 0) {
      alert(this.translateService.instant('PLEASE_LOCATION'));
      return;
    }
    this.showSpinner.emit(true);
    const payload: LocationDataProcessMeasure = {
      type: 'erase',
      project_device_location: this.selectedLocation.id,
    };
    const start_date = this.projectMeasureService.formatDateToString(this.timeStartPicker, this.dateStartPicker);
    const end_date = this.projectMeasureService.formatDateToString(this.timeEndPicker, this.dateEndPicker);
    payload.start_date = start_date;
    payload.end_date = end_date;
    payload.comment = this.comment;
    this.projectMeasureService.postLocationDataProcessMeasure(payload)
      .subscribe(
        () => {
          this.toastr.success(this.translateService.instant('ERASER_CREATED'));

          this.getDataProcessMeasures(this.selectedLocation.id);
        },
        () => this.showSpinner.emit(false)
      );
  }

  private getDataProcessMeasures(locationId: number) {
    this.showSpinner.emit(true);
    this.projectMeasureService.getLocationDataProcessMeasure(locationId, 'erase')
      .subscribe(
        (dataProcessMeasures) => {
          this.selectedLocationDataProcessMeasures = dataProcessMeasures || [];

          for (const selectedLocationDataProcessMeasuresKey in this.selectedLocationDataProcessMeasures) {
            this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].dateStartToDisplay =
              this.projectMeasureService.formatDateToDisplay(this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].startDate);

            this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].dateEndToDisplay =
              this.projectMeasureService.formatDateToDisplay(this.selectedLocationDataProcessMeasures[selectedLocationDataProcessMeasuresKey].endDate);


          }
          this.showSpinner.emit(false);
        }
      );
  }

}
